export default __webpack_public_path__ + "static/map/img/sense_logo_dark.ff86ae1.gif";